import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

import { ConfirmAccountOtp } from '@project/types';
import { userAuthService } from '@project/services';

import { Button, ConfirmationOtpForm, FormContainer } from '../../../components';

const SignUpSuccessScreen: React.FC = () => {
  const history = useHistory();
  const location = useLocation<{ email?: string; phoneNumber?: string }>();

  const initialValues: ConfirmAccountOtp = {
    email: location.state?.email ?? '',
    phoneNumber: location.state?.phoneNumber ?? '',
    otp: '',
  };

  const onSubmit = (formData: ConfirmAccountOtp) => {
    return userAuthService.accountConfirmationOtp(formData);
  };

  const onSuccess = () => {
    toast.success('Successfully Sent', { duration: 5000 });
    history.push('/login');
  };

  const onBack = () => {
    history.push('/sign-up');
  };

  return (
    <FormContainer className="p-5">
      <Toaster position="top-center" />
      <p className="w-full text-center px-10">
        You have successfully signed up. We have sent you a verification email and/or SMS. Please
        confirm your account by providing the OTP.
      </p>
      <div className="flex flex-col">
        <ConfirmationOtpForm
          initialValues={initialValues}
          submitForm={onSubmit}
          onSuccess={onSuccess}
        />
        <Button onClick={onBack} type="text" className="font-bold -ml-1">
          Back
        </Button>
      </div>
    </FormContainer>
  );
};

export default SignUpSuccessScreen;
